import { render } from "./OffcanvasConfigurationForm.vue?vue&type=template&id=403217ff&scoped=true"
import script from "./OffcanvasConfigurationForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasConfigurationForm.vue?vue&type=script&lang=js"

import "./OffcanvasConfigurationForm.vue?vue&type=style&index=0&id=403217ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403217ff"]])

export default __exports__